import { ref } from 'vue'
import axios from 'axios'

const EXCLUDED_MANAGEMENT_DASHBOARD_SUBSIDIARY_IDS = new Set([15])

function createTypeState() {
  return {
    subsidiaries: ref([]),
    selectedSubsidiary: ref('')
  }
}

const stateByType = {
  non_hospital: createTypeState(),
  hospital: createTypeState()
}

let apiInstance = null
function getApi() {
  if (!apiInstance) {
    apiInstance = axios.create({
      baseURL: import.meta.env.VITE_API_URL,
      timeout: import.meta.env.VITE_API_TIMEOUT,
      headers: { 'Content-Type': 'application/json' }
    })
    apiInstance.interceptors.request.use((config) => {
      const token = sessionStorage.getItem('token')
      if (token) config.headers.Authorization = `Bearer ${token}`
      return config
    })
  }
  return apiInstance
}

export function filterDashboardSubsidiaries(list, subsidiaryType) {
  if (subsidiaryType !== 'hospital' && subsidiaryType !== 'non_hospital') {
    return list || []
  }
  return (list || []).filter(
    (s) => !EXCLUDED_MANAGEMENT_DASHBOARD_SUBSIDIARY_IDS.has(Number(s.id))
  )
}

function getState(subsidiaryType) {
  return stateByType[subsidiaryType] || stateByType.non_hospital
}

export function useManagementDashboardSubsidiary() {
  async function loadSubsidiaries(subsidiaryType) {
    const s = getState(subsidiaryType)
    if (!subsidiaryType || (subsidiaryType !== 'hospital' && subsidiaryType !== 'non_hospital')) {
      s.subsidiaries.value = []
      return
    }
    try {
      const api = getApi()
      const response = await api.get('/api/subsidiary', { params: { type: subsidiaryType } })
      s.subsidiaries.value = filterDashboardSubsidiaries(response.data, subsidiaryType)
    } catch {
      s.subsidiaries.value = []
    }
  }

  function setSelectedSubsidiary(subsidiaryType, id) {
    const s = getState(subsidiaryType)
    s.selectedSubsidiary.value = id === 'all' || id === '' || id == null ? 'all' : id
  }

  return {
    getState,
    loadSubsidiaries,
    setSelectedSubsidiary
  }
}
